/* ------------------------------------------------------------------------------
@name: Section12
@description: Section12
--------------------------------------------------------------------------------- */

const Section12 = (() => {
  // - section12
  const handleSection12 = () => {
    // init controller
    const controller = new ScrollMagic.Controller();

    const section_12 = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-1",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-1", 0.3, {
        opacity: 1,
      })
      .addTo(controller);

    const section_12a = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-2",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-1", 0.3, {
        opacity: 0,
      })
      .addTo(controller);

    const section_12b = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-1",
      triggerHook: 0.3,
    })
      .setTween(".mobil-putih-3", 0.3, {
        opacity: 1,
        visibility: "visible",
      })
      .addTo(controller);

    const section_12c = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-2",
      triggerHook: 0.7,
    })
      .setTween(".mobil-putih-3", 0.3, {
        opacity: 0,
        visibility: "hidden",
      })
      .addTo(controller);

    const section_12d = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-1",
      triggerHook: 0.3,
    })
      .setTween(".mobil-putih-3", 0, {
        display: "block",
      })
      .addTo(controller);

    const section_12e = new ScrollMagic.Scene({
      triggerElement: ".section-12-trigger-2",
      triggerHook: 0.7,
    })
      .setTween(".mobil-putih-3", 0, {
        display: "none",
      })
      .addTo(controller);

    $(".gambar-garam").click(function () {
      $(".teks-garam").removeClass("opacity-0");
    });

    $(".gambar-beras").click(function () {
      $(".teks-beras").removeClass("opacity-0");
    });
  };

  // - init
  const init = () => {
    handleSection12();
  };

  return {
    init,
  };
})();

export default Section12;
